import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiClock, FiStar, FiEye } = FiIcons;

const Hero = () => {
  return (
    <section className="min-h-screen flex items-center justify-center relative pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-8"
        >
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 font-playfair">
            Kudawe Bird Wave
            <span className="gradient-text block">Experience</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
            The only luxury birding retreat at the Kudawe-Ullinduwawa border. 
            Experience the world's largest mixed-species bird flocks in comfort.
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-12">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="glass rounded-lg p-4 flex items-center space-x-3"
            >
              <SafeIcon icon={FiMapPin} className="text-emerald-400 text-xl" />
              <span className="text-white font-medium">1.1km from Kudawe Gate</span>
            </motion.div>
            
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="glass rounded-lg p-4 flex items-center space-x-3"
            >
              <SafeIcon icon={FiEye} className="text-blue-400 text-xl" />
              <span className="text-white font-medium">34 Endemic Species</span>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.05 }}
              className="glass rounded-lg p-4 flex items-center space-x-3"
            >
              <SafeIcon icon={FiStar} className="text-yellow-400 text-xl" />
              <span className="text-white font-medium">9.8/10 Location Rating</span>
            </motion.div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover-lift pulse-glow"
            >
              Book Birding Package
            </motion.button>
            
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="glass text-white px-8 py-4 rounded-full font-semibold text-lg hover-lift border border-white/20"
            >
              Download Bird Checklist
            </motion.button>
          </div>
        </motion.div>

        {/* Hero Video/Image Placeholder */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="relative"
        >
          <div className="glass rounded-2xl p-8 max-w-4xl mx-auto">
            <div className="aspect-video bg-gradient-to-br from-emerald-600/30 to-teal-600/30 rounded-xl flex items-center justify-center">
              <div className="text-center">
                <SafeIcon icon={FiEye} className="text-6xl text-white/60 mx-auto mb-4" />
                <p className="text-white/80 text-lg">Blue Magpie in Flight</p>
                <p className="text-white/60">Captured at Jansen's Garden</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;